(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailInsightController', ContentDetailInsightController);

    /* @ngInject */
    function ContentDetailInsightController($scope, $filter, $state, CONTENT_META, CONTENT_INSIGHT_META, Content, content_type, id, CONTENT_RECOGNITION_META) {

        var vm = this;

        vm.loadingData = true;

        vm.contentMetaData = angular.copy($filter('filter')(CONTENT_META, {
            type: content_type.replace(/_/g, '-')
        })[0]);

        vm.insightSections = angular.copy(CONTENT_INSIGHT_META[content_type].sections);

        vm.contentModel = null;

        vm.hasInsights = function() {
            return CONTENT_INSIGHT_META[content_type] != undefined;
        }

        vm.hasRecognition = function() {
            return CONTENT_RECOGNITION_META[content_type] != undefined;
        }

        vm.handleBackClick = function() {
            if(!!sessionStorage.getItem('DocumentListingQueryParams')) {
                $state.go('storm.content-documents', JSON.parse(sessionStorage.getItem('DocumentListingQueryParams')));
            } else {
                $state.go('storm.admin-contents');
            }
        }

        vm.loadData = function() {
            if (id) {
                Content.get({
                    id: id
                }, function(result) {
                    vm.contentModel = result;
                    vm.loadingData = false;
                });
            }
        }
        vm.loadData();
    }
})();
